import { render } from "./vserviceusercens.vue?vue&type=template&id=ea480302&scoped=true"
import script from "./vserviceusercens.vue?vue&type=script&lang=js"
export * from "./vserviceusercens.vue?vue&type=script&lang=js"

import "./vserviceusercens.vue?vue&type=style&index=0&id=ea480302&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea480302"]])

export default __exports__